export default __webpack_public_path__ + "static/karai-2bdb6948f6b2e6f9213a9749fb6ea30b.webp";